import { Lock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { laudoAguardandoCredito } from "@shared/laudo-credito";

/** Marca o laudo bloqueado por falta de crédito do Parceiro. */
export function AguardandoCreditoBadge({
  laudo,
}: {
  laudo: { aguardandoCreditoDesde?: Date | string | null };
}) {
  if (!laudoAguardandoCredito(laudo)) return null;

  return (
    <Badge
      variant="outline"
      className="gap-1 border-amber-300 bg-amber-50 text-xs text-amber-800"
    >
      <Lock className="h-3 w-3" aria-hidden="true" />
      Aguardando crédito
    </Badge>
  );
}
